<div ngbDropdown class="d-inline-block" style="float: center;">
    <button type="button" class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle style="min-width: 150px;">
				{{selectedOption}}
			</button>
    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-height">

        <button *ngFor="let option of DropDownOptions" ngbDropdownItem (click)="setSelected(option)">{{option}}</button>

    </div>
</div>